export let VerificationPromptCategory;

(function (VerificationPromptCategory) {
  VerificationPromptCategory["GoodActor"] = "good_actor";
  VerificationPromptCategory["BadActor"] = "bad_actor";
})(VerificationPromptCategory || (VerificationPromptCategory = {}));

export let VerificationMethods;

(function (VerificationMethods) {
  VerificationMethods["Email"] = "email";
  VerificationMethods["Phone"] = "phone";
  VerificationMethods["EmailCode"] = "email_code";
  VerificationMethods["Google"] = "google";
})(VerificationMethods || (VerificationMethods = {}));

export let VerificationActions;

(function (VerificationActions) {
  VerificationActions["BalanceWithdrawal"] = "balance_withdrawal";
  VerificationActions["AccountDeletion"] = "account_deletion";
  VerificationActions["DataExport"] = "data_export";
})(VerificationActions || (VerificationActions = {}));